export default __webpack_public_path__ + "static/media/AditiG.7b58ff6a.jpg";